// extracted by mini-css-extract-plugin
export default {"container":"GetStarted_container__OxlkT","description":"GetStarted_description__t12Ds"};